<template>
    <div class="error-screen">
        <!-- top navbar-->
        <Navbar></Navbar>
        <!-- content-->
        <div class="content">
            <div class="inner">
                <p class="title">
                    <span class="b">Oooopsss!</span> Provjeri jesi li sve dobro prijavio!
                </p>
                <p class="text">
                    min. 2 zadatka iz Matematike; max 3 <br>
                    min. 2 zadatka iz Popularne znanosti; max 3 <br>
                    min. 1 zadatak iz Digitalnog društva; max 2 <br>
                    min. 1 zadatak iz Engleskog jezika; max 2
                </p>
                <a href="#" @click.prevent="goBack" class="button-1 blue no-arrow"><span>Nazad na prijavu</span></a>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from './Navbar.vue'
import { GlobalEvents } from '../event-bus'

export default {
    name: 'errorScreen',
    components: {
        Navbar
    },
    methods: {
        goBack () {
            this.$emit(GlobalEvents.CLOSE_OVERLAY)
        }
    }
}
</script>

<style lang="scss" scoped>
.error-screen {
    position: absolute;
    z-index: 550;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    min-height: 100vh;
    background-color: #f0f1f2;
    background-image: url(~@/assets/img/sample/error-screen-bg.png);
    background-repeat: no-repeat;
    background-position: center top -35px;
    background-size: contain;
}

.content {
    width: 100%;
    min-height: 100vh;
    padding-top: 80%;
    @media only screen and (max-width: 320px) {
        padding-top: 70%;
    }
    .inner {
        width: 100%;
        position: relative;
        top: 30px;
    }
    .title {
        font-family: $font-mPlus;
        max-width: 322px;
        font-size: 28px;
        line-height: 33px;
        letter-spacing: -0.2px;
        color: #000;
        font-weight: 800;
        margin: auto auto 10px auto;
        z-index: 2;
        position: relative;
        @media only screen and (max-width: 320px) {
            max-width: 270px;
            font-size: 23px;
            line-height: 28px;
        }
        span.b {
            color: #65aaeb;
        }
    }
    .text {
        font-family: $font-axiforma;
        font-size: 14px;
        line-height: 1.6;
        margin: auto auto 10px auto;
        max-width: 322px;
        margin-bottom: 30px;
        @media only screen and (max-width: 320px) {
            max-width: 270px;
            font-size: 12px;
        }
    }
    .button-1 {
        display: block;
        margin: auto;
        max-width: 200px;
    }
}

.top-bar {
    position: absolute;
    z-index: 10;
    padding: 22px 0 22px 0;
    top: 0;
    left: 0;
    background-color: #fff;
    width: 100%;
    pointer-events: auto;

    .back-button {
        display: block;
        transition: background 0.3s ease;
        position: absolute;
        left: 30px;
        top: 15px;
        width: 25px;
        height: 25px;
        background: url(~@/assets/img/icons/arrow-back-black.png) 50% no-repeat;
        background-size: 24px;
        @media only screen and (max-width: 320px) {
            top: 14px;
            left: 23px;
            background-size: 20px;
        }
    }
    .title {
        font-family: $font-axiforma;
        text-transform: uppercase;
        font-weight: 800;
        font-size: 12px;
        letter-spacing: 1px;
        text-align: center;
        margin-bottom: 0px;
        @media only screen and (max-width: 320px) {
            font-size: 10px;
        }
    }
}

</style>
